const throttle = {
  bind: function(el, { value: { fn, time } }) {
    if (typeof fn !== "function") return;
    el._flag = true;
    el._timer = null;
    el.handler = function() {
      if (!el._flag) return;
      el._flag && fn();
      el._flag = false;
      if (el._timer !== null) {
        clearTimeout(el._timer);
        el._timer = null;
      }
      el._timer = setTimeout(() => {
        el._flag = true;
      }, time);
    };
    el.addEventListener("click", el.handler);
  },
  unbind: function(el, binding) {
    el.removeEventListener("click", el.handler);
  }
};

export default throttle;



// WEBPACK FOOTER //
// ./src/directives/throttle.js